import React from 'react';
import './Footer.css';
import ThemeToggle from './ThemeToggle';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-text">
        <div className="copyright">© {currentYear} Dominik Hofacker</div>
        <div className="footer-subtitle">Design Lead, Human Interface & Prototyping</div>
      </div>
      
      <nav className="footer-nav">
        <a 
          href="https://www.linkedin.com/in/dominik-design/" 
          className="footer-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </a>
        <a 
          href="mailto:dominik.hofacker@gmail.com?subject=Let%27s%20Chat&body=Hi%20Dominik%2C%0A%0AI%20came%20across%20your%20website%20and%20would%20love%20to%20connect." 
          className="footer-link"
        >
          Email
        </a>
        <a 
          href="https://x.com/dohodesign" 
          className="footer-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          X
        </a>
        <ThemeToggle />
      </nav>
    </footer>
  );
};

export default Footer;
